import moment from "moment";
import React, { useCallback, useState } from "react";
import DeclarationModal from "./DeclarationModal";
import "./index.scss";
import { Container, Row,Col } from "react-bootstrap";

const Declarations = (props) => {
  const { documentData,isMobile } = props;
  const [showModal, setShowModal] = useState(false);
  
  const handleClick = useCallback(() => {
    setShowModal(true);
  }, []);

  return (

    <>
    <Col xs={12} md={12} lg={12} >
    { documentData?.consent_type && 
    (<Row className="py-2 border-theme-grey rounded">
      <Col xs={10} md={8} lg={7} className="border-sm-end">
          <div className="d-block d-md-flex align-items-center h-100">
              <p className="m-0 fw-bold fs-15px">
                  {documentData?.consent_type}
              </p>
              <p className="m-0 fs-14px d-block d-md-none">
                  {' '}
                  Agreed on:{' '}
                  {moment(new Date(documentData?.approved_at)).format(
                      'DD MMM YYYY hh:mm A'
                  )}
              </p>
          </div>
      </Col>
      <Col xs={12} md={4} lg={4} className="d-none d-md-block">
          <div className="d-flex align-items-center justify-content-end h-100">
              <div className="py-2 pe-4 border-end">
                  <p className="m-0 fs-12px">
                      {' '}
                      Agreed on:{' '}
                      {moment(
                          new Date(documentData?.approved_at)
                      ).format('DD MMM YYYY hh:mm A')}
                  </p>
              </div>
          </div>
      </Col>
      <Col xs={2} md={1} lg={1}>
          <div className="d-flex align-items-center justify-content-center h-100">
              <p
                  className="text-theme fs-12px fw-bold m-0 text-center cursor-pointer"
                  onClick={handleClick}
              >
                  View
              </p>
          </div>
      </Col>
    </Row>)
    }
    </Col>
  {showModal && (
      <DeclarationModal
          show={true}
          onHide={() => setShowModal(false)}
          title={documentData?.consent_type}
          body={documentData?.consent_text}
      />
  )}
    </>
  );
};

export default Declarations;
